import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { LocationCode } from '../models/location-codes.models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationCodesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);

  baseUrl = 'https://dev-api.thportal.ca/api/v2/locations';

  createLocationCode(
    locationCode: Omit<LocationCode, 'id' | 'location' | 'discontinued' | 'inActive'>
  ): Observable<LocationCode> {
    return this.#http.postData<LocationCode>(this.baseUrl, { showLoader: true, showMessage: true }, locationCode);
  }

  readLocationCodes(): Observable<LocationCode[]> {
    return this.#http.getData<LocationCode[]>(`${this.baseUrl}?includingInactive=true`, {
      showLoader: true,
      showMessage: true
    });
  }

  readLocationCodeById(id: string): Observable<LocationCode> {
    return this.#http.getData<LocationCode>(`${this.baseUrl}/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }

  updateLocationCode(id: string, locationCode: Omit<LocationCode, 'id'>): Observable<LocationCode> {
    return this.#http.putData<LocationCode>(`${this.baseUrl}/${id}`, locationCode, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteLocationCode(id: string): Observable<void> {
    return this.#http.deleteData<void>(`${this.baseUrl}/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }
}
